import { useParams } from 'react-router-dom';
import { getDepositById, getDepositByIdStock } from '../../../services/depositsService';
import React, { useState, useEffect } from 'react';
import { Page, Layout, LegacyCard, EmptyState, LegacyStack, Text, Badge } from '@shopify/polaris';
import { depositTypeBadgeStatus, depositTypeLabel, isRetailDepositType } from '../../../helpers/depositTypes';
import ViewDepositPrimaryActions from '../../UI/Deposits/ViewDepositPrimaryActions';
import ProductsWrapper from '../../UI/Products/ProductsWrapper';
import ProductStockTable from '../../UI/Tables/ProductStockTable';
import ProductFilters from '../../UI/Products/ProductFilters';
import { useHistory } from 'react-router-dom';

const Deposit = () => {
  const { id } = useParams();
  const [deposit, setDeposit] = useState(null);
  const [stock, setStock] = useState(null);
  const [canDelete, setCanDelete] = useState(false);
  const [filters, setFilters] = useState(null);
  const [numbers, setNumbers] = useState({});
  const navigate = useHistory();

  const loadStock = (page = 1, filters, rebuild = false) =>
    getDepositByIdStock(id, { page, ...filters }).then((r) => {
      setStock({ ...r.data, new: rebuild });
      setCanDelete(r.data.metadata.count === 0);
      setNumbers({
        stockQty: r.data.metadata.stockQty,
        distinctProducts: r.data.metadata.distinctProducts,
        distinctVariants: r.data.metadata.distinctVariants,
      });
    });

  const loadDeposit = () =>
    getDepositById(id).then((r) => {
      setDeposit(r.data);
      setNumbers({
        stockQty: r.data.stockQty,
        distinctProducts: r.data.distinctProducts,
        distinctVariants: r.data.distinctVariants,
      });
    });

  const TableComponent = (args) => (
    <div className="deposit_stock">
      <ProductStockTable {...args} deposit={deposit} />
    </div>
  );

  useEffect(() => {
    loadDeposit();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (filters) loadStock(1, filters, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  return (
    <>
      {deposit && (
        <Page
          backAction={{ content: 'Ver depósitos', onAction: () => navigate.goBack() }}
          title={deposit.name}
          subtitle={
            deposit.parent ? `${deposit.code} · Grupo: ${deposit.parent.name}` : `${deposit.code}`
          }
          titleMetadata={
            !deposit.isOnlyGroup && (
              <LegacyStack spacing="extraTight">
                <Badge status={depositTypeBadgeStatus(deposit.depositType)}>
                  {depositTypeLabel(deposit.depositType)}
                </Badge>
                {!isRetailDepositType(deposit.depositType) && (
                  <Badge>Fuera del perímetro de informes</Badge>
                )}
              </LegacyStack>
            )
          }
          primaryAction={
            <ViewDepositPrimaryActions
              id={id}
              canDelete={canDelete}
              isOnlyGroup={deposit.isOnlyGroup}
              onUpdateDeposit={loadDeposit}
            />
          }
          divider
        >
          <Layout>
            <Layout.Section>
              <LegacyCard>
                {Object.keys(numbers).length > 0 && (
                  <LegacyCard.Section>
                    <LegacyStack distribution="fill">
                      <span>
                        <Text variant="headingXs" weight="semibold">
                          Uds.
                        </Text>
                        <Text variant="heading3xl">{numbers.stockQty ?? 0}</Text>
                      </span>
                      <span>
                        <Text variant="headingXs" weight="semibold">
                          Serie-Color
                        </Text>
                        <Text variant="heading3xl">{numbers.distinctProducts}</Text>
                      </span>
                      <span>
                        <Text variant="headingXs" weight="semibold">
                          SKU
                        </Text>
                        <Text variant="heading3xl">{numbers.distinctVariants}</Text>
                      </span>
                    </LegacyStack>
                  </LegacyCard.Section>
                )}
                <LegacyCard.Section title="Filtros">
                  <ProductFilters onFilterSelected={(filters) => setFilters(filters)} />
                </LegacyCard.Section>
              </LegacyCard>
            </Layout.Section>
            <Layout.Section>
              {stock && !stock.data.length && (
                <LegacyCard>
                  <LegacyCard.Section>
                    <EmptyState
                      heading="El depósito no contiene mercancía"
                      image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
                    ></EmptyState>
                  </LegacyCard.Section>
                </LegacyCard>
              )}

              {stock && (
                <ProductsWrapper
                  data={stock}
                  TableComponent={TableComponent}
                  loadPage={() => loadStock(stock.metadata.page + 1, filters)}
                />
              )}
            </Layout.Section>
          </Layout>
        </Page>
      )}
    </>
  );
};

export default Deposit;
